/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'; 

const Contactus = () => {
 
    return (
        <>

            <Grid container spacing={4}>

                <Grid item xs={12} sm={12} md={12}  >
                    <div >
                        <Typography variant="h1" align="center" style={{ marginTop: '100px', marginBottom: '20px' }} paragraph>
                            Contact Us
                        </Typography>
                        
                    </div>
                </Grid>

            </Grid>

        </>
    );
}



export default Contactus;